const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

export const getAcademyCategoryViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  return [
    {
      title: t('Informazioni Generali'),
      fields: [
        { text: t('Titolo'), value: display(item.title) },
        {
          text: t('Outlet Village'),
          value: display(item.shopping_center?.title),
        },
        { text: t('Macro-Area'), value: display(item.macro_area) },
        { text: t('Anno Edizione'), value: display(item.year) },
      ],
    },
  ];
};
